<template>
  <div class="imgList">
    <ad-drawer
      :visible="imgListShow"
      showBtn
      @open="open"
      @cancel="close"
      @sure="sure"
      :configDraw="configDraw"
    >
      <el-tabs
        v-if="tabList.length > 0"
        v-model="activeName"
        @tab-click="handleTabsClick"
        class=""
      >
        <el-tab-pane
          v-for="item in tabList"
          :key="item.name"
          :label="item.label"
          :name="item.name"
        >
          <keep-alive :include="item.componentName"
            ><component
              ref="keepComponent"
              :key="activeName + keySuffix"
              :is="activeName === item.name ? item.componentName : null"
              :isOpen="activeName"
              :saveAdFileParam="saveAdFileParam"
              :uploadTypes="uploadTypes"
              :chooseList="chooseList"
              :pageObj="pageObj"
              :platform="item.name === 'AD_MATERIAL' ? '' : platform"
              :lpu="lpu"
              :productId="snapProductId"
              v-bind="{ ...adMaterialParams, platform: item.name === 'AD_MATERIAL' ? '' : platform }"
              :mediaType="uploadTypes == 'img' ? 'IMAGE' : 'VIDEO'"
              :mediaTypeDisabled="true"
              @choose="choose"
              @chooseAdMaterial="chooseAdMaterial"
              @changeTotal="changeTotal"
            ></component
          ></keep-alive>
        </el-tab-pane>
      </el-tabs>
      <div
        class="text-right h-4"
        v-if="activeName !== 'AD_MATERIAL'"
      >
        <el-pagination
          small
          layout="prev, pager, next"
          :total="totalMap[activeName]"
          :page-size="pageObj.pageSize"
          @current-change="handleCurrentChange"
          :current-page.sync="pageObj.page"
        >
        </el-pagination>
      </div>
    </ad-drawer>
  </div>
</template>
<script>
import AdAccountMaterial from '@/views/adManagement/createAd/components/adsComponents/AdAccountMaterial.vue';
import PersonalMaterial from '@/views/adManagement/createAd/components/adsComponents/PersonalMaterial.vue';
import { adDrawer, AdMaterialsChild } from '@adCommonComponent';
import { cloneDeep } from 'lodash';
import { saveOptLog } from '@adCommonComponent/serve/material.js';
export default {
  components: { adDrawer, AdAccountMaterial, PersonalMaterial, AdMaterialsChild },
  // props: ['imgListShow', 'uploadTypes', 'selectList', 'limit', 'adSeriesInfo','saveAdFileParam'],
  props: {
    // 布尔类型，默认值为false
    imgListShow: {
      type: Boolean,
      default: false,
    },
    // 数组类型，默认值为空数组1
    uploadTypes: {
      type: String,
      default: 'img',
    },
    // 对象类型，默认值为空对象
    adSeriesInfo: {
      type: Object,
      default: () => ({}),
    },
    // 数字类型，默认值为0
    limit: {
      type: Number,
      default: 0,
    },
    // 字符串类型，默认值为空字符串
    saveAdFileParam: {
      type: Object,
      default: () => ({}),
    },
    // 自定义验证函数
    selectList: {
      type: Array,
      default: () => [],
    },
    adMaterialParams: {
      type: Object,
      default: () => ({}),
    },
    tabList: {
      type: Array,
      default: () => [
        {
          label: '个人素材库',
          name: 'SELF_MATERIAL',
          componentName: 'PersonalMaterial',
        },
        // {
        //   label: '广告账户',
        //   name: 'AD_ACT_MEDIA',
        //   componentName: 'AdAccountMaterial',
        // },
        {
          label: '广告素材库',
          name: 'AD_MATERIAL',
          componentName: 'AdMaterialsChild',
        },
      ],
    },
    platform: {
      type: String,
      default: 'facebook',
    },
    lpu: {
      type: String,
      default: '',
    },
    snapProductId: {
      type: String || Number,
      default: '',
    },
  },
  data() {
    return {
      list: [],
      checkAll: false,
      isIndeterminate: true,
      accountAll: [],

      radio2: '',
      startTime: '',
      endTime: '',
      chooseList: [],
      urlList: [],
      keyword: '',
      chooseAccount: false,
      date: '',
      configDraw: {
        'with-header': false,
        size: '1252px',
        'append-to-body': true,
      },
      activeName: 'SELF_MATERIAL',
      // tabList: [
      //   {
      //     label: '个人素材库',
      //     name: 'SELF_MATERIAL',
      //     componentName: 'PersonalMaterial',
      //     optSourceType: 'SELF_LIB',
      //   },
      //   {
      //     label: '广告账户',
      //     name: 'AD_ACT_MEDIA',
      //     componentName: 'AdAccountMaterial',
      //     optSourceType: 'CLOUD_LIB',
      //   },
      // ],
      allTabList: [
        {
          label: '个人素材库',
          name: 'SELF_MATERIAL',
          componentName: 'PersonalMaterial',
          optSourceType: 'SELF_LIB',
        },
        {
          label: '广告账户',
          name: 'AD_ACT_MEDIA',
          componentName: 'AdAccountMaterial',
          optSourceType: 'CLOUD_LIB',
        },
        {
          label: '广告账户',
          name: 'AD_MATERIAL',
          componentName: 'AdAccountMaterial',
          optSourceType: 'SELF_LIB',
        },
      ],
      totalMap: {
        AD_ACT_MEDIA: 0,
        SELF_MATERIAL: 0,
      },
      pageObj: {
        page: 1,
        pageSize: 18,
      },
      keySuffix: 0, // 用于生成唯一的 key
      adMaterialList: [], // 广告素材库选中的列表
    };
  },
  computed: {
    langId() {
      return this.adSeriesInfo?.sale?.langId;
    },
    proId() {
      return this.adSeriesInfo?.sale?.productId;
    },
  },
  methods: {
    handleTabsClick(tab, event) {
      if (tab.name !== 'AD_MATERIAL ') {
        this.adMaterialList = [];
      }
    },

    changeTotal(total) {
      this.totalMap[this.activeName] = total;
    },
    handleCurrentChange(v) {
      this.pageObj.page = v;
      this.$refs.keepComponent[0].getList();
    },
    close() {
      console.log('close');
      this.$emit('close', 'imgListShow');
      this.urlList = [];
      this.chooseList = [];
      this.activeName = '';
    },

    open() {
      console.log('open');
      // 改变 key 值以重新渲染组件
      this.keySuffix += 1;
      this.activeName = 'SELF_MATERIAL';
    },
    chooseAdMaterial(list) {
      console.log('ppns--------chooseAdMaterial', list);
      this.urlList = list;
    },
    // 点击选择素材
    choose(id, imgItem) {
      console.log('ppns--------choose', imgItem);
      console.log(id, imgItem, 'id, imgItem');
      const img = cloneDeep(imgItem);
      img.sourceType = this.activeName;
      if (this.activeName === 'SELF_MATERIAL') {
        img.id = img.file_id;
        img.originalFilename = img.file_name;
        img.md5 = img.md5_code;
        img.mediaType = img.type == 1 ? 'IMAGE' : 'VIDEO';
      }

      if (this.limit == 1) {
        this.chooseList = [id];
        this.urlList = [img];
      } else {
        console.log(this.urlList, img, 'img');
        if (this.chooseList.indexOf(id) >= 0) {
          let i = this.chooseList.indexOf(id);
          // console.log(this.chooseList.indexOf(id));
          this.chooseList.splice(i, 1);
          this.urlList.splice(i, 1);
        } else {
          if (this.chooseList.length >= this.limit) {
            this.$message({
              type: 'warning',
              message: `最大数量为${this.limit}哦~~`,
            });
            return false;
          }
          this.chooseList.push(id);
          this.urlList.push(img);
        }
      }
      console.log(img, this.urlList, 'this.urlList');
    },
    // 广告素材库选择
    chooseAdMaterial(list) {
      console.log(list, 'listlistlistlist');
      list.forEach((item) => {
        item.id = item.file_id;
        item.sourceType = this.activeName == 'AD_ACT_MEDIA' ? 'AD_ACT_MEDIA' : 'SELF_MATERIAL';
      });
      this.urlList = this.urlList.concat(list);
    },
    // 关闭弹窗
    async sure() {
      try {
        console.log('ppns--sure- this.activeName', this.activeName);
        if (this.$refs.keepComponent[0] && this.activeName === 'AD_MATERIAL') {
          await this.$refs.keepComponent[0].checkAndUpload();
        }
      } catch (error) {
        console.log(error);
      }
      let sourceType = this.activeName == 'AD_ACT_MEDIA' ? 'AD_ACT_MEDIA' : 'SELF_MATERIAL';
      if (this.platform == 'facebook') {
        const optSourceType = this.allTabList.find((item) => item.name === this.activeName).optSourceType;
        await Promise.all(
          this.urlList.map(async (item) => {
            item.mediaOptLogId = await this.getOptLogId(item.id, optSourceType, item.mediaType);
          }),
        );
        console.log(sourceType, 'sourceTypesourceTypesourceType');
        this.$emit('urlList', this.urlList, sourceType);
        this.close();
      } else {
        console.log('ppns--origin-urllist', this.urlList);
        this.$emit('urlList', this.urlList, sourceType);
        this.close();
      }
    },
    async getOptLogId(fileId, sourceType, mediaType) {
      const optRes = await saveOptLog({
        platform: 'facebook',
        adAccountId: this.saveAdFileParam.adAccountId,
        fileId,
        sourceType,
        mediaType,
      });
      return optRes.data.id;
    },
  },
  watch: {
    selectList: {
      handler() {
        this.chooseList = JSON.parse(JSON.stringify(this.selectList));
      },
      deep: true,
    },
    activeName(val) {
      if (val === 'SELF_MATERIAL') {
        this.configDraw.size = '1252px';
      } else if (val === 'AD_MATERIAL') {
        this.configDraw.size = '1252px';
      }
    },
  },
  created() {
    console.log('created');
  },
  mounted() {
    console.log('mounted');
  },
  beforeDestroy() {
    console.log('beforeDestroy');
  },
  destroyed() {
    console.log('destroyed');
  },
};
</script>
<style lang="scss">
.demo-drawer__footer {
  text-align: center;
  padding: 15px 0;
  // background: #efefef;
  border-top: 1px solid #ddd;
}

.accountCard {
  // padding: 15px;
  .headTop {
    // padding: 15px;
  }

  .btnGroup {
    padding-top: 10px;
    // background: #efefef;
    border-top: 1px solid #efefef;
    text-align: center;
  }

  .accountTop {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .right {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .refresh {
      margin-right: 15px;
      font-size: 12px;
      color: #666;
      text-align: center;
    }
  }

  .accountMain {
    margin-top: 15px;
    padding-bottom: 50px;

    .el-checkbox-group {
      display: flex;
      flex-wrap: wrap;

      .el-badge__content.is-fixed.is-dot {
        top: 4px;
        right: 10px;
      }

      .el-checkbox__input {
        margin-top: 3px;
      }

      .accountInfo {
        display: flex;
        align-items: flex-start;

        i {
          font-size: 18px;
          color: #409eff;
          margin-right: 5px;
        }
      }

      .name {
        width: 240px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        // font-weight: bold;
        color: #333;
        margin-bottom: 6px;
      }

      span {
        font-size: 12px;
        color: #999;
      }
    }

    .el-checkbox {
      width: 44%;
      margin-bottom: 10px;
      display: flex;
      align-items: flex-start;
    }
  }
}

.el-select-dropdown.el-popper .el-select-dropdown__empty {
  display: none;
}

.imgList {
  // padding: 0 20px;
  .demo-form-inline {
  }

  .el-drawer.rtl {
    outline: none;

    * {
      outline: none;
    }
  }
}
</style>
